/*
  Copied from https://github.com/lhz516/react-h5-audio-player/blob/master/src/VolumeBar.tsx (MIT License)
*/
import classNames from 'classnames';
import React, { Component } from 'react';
import { getPosY, getPosX } from '../utils';
export class VolumeControls extends Component {
    constructor() {
        super(...arguments);
        this.hasAddedAudioEventListener = false;
        this.lastVolume = this.props.volume; // To store the volume before clicking mute button
        this.state = {
            currentVolumePos: `${((this.lastVolume / 1) * 100 || 0).toFixed(2)}%`,
            hasVolumeAnimation: false,
            isDraggingVolume: false,
        };
        // get volume info while dragging by indicator mouse or touch
        this.getCurrentVolume = (event) => {
            const { audio, alignment = 'vertical' } = this.props;
            if (!this.volumeBarEl) {
                return {
                    currentVolume: audio.volume,
                    currentVolumePos: this.state.currentVolumePos,
                };
            }
            const volumeBarRect = this.volumeBarEl.getBoundingClientRect();
            const maxRelativePos = alignment === 'vertical' ? volumeBarRect.height : volumeBarRect.width;
            const relativePos = alignment === 'vertical' ?
                getPosY(event) + volumeBarRect.height - volumeBarRect.bottom :
                volumeBarRect.left - getPosX(event) + volumeBarRect.width;
            let currentVolume;
            let currentVolumePos;
            const dimensionToCompare = alignment === 'vertical' ? volumeBarRect.height : volumeBarRect.width;
            if (relativePos < 0) {
                currentVolume = 1;
                currentVolumePos = '100%';
            }
            else if (relativePos > dimensionToCompare) {
                currentVolume = 0;
                currentVolumePos = '0%';
            }
            else {
                currentVolume = 1 - (relativePos / maxRelativePos);
                currentVolumePos = `${(1 - (relativePos / maxRelativePos)) * 100}%`;
            }
            return { currentVolume, currentVolumePos };
        };
        this.handleClickVolumeButton = () => {
            const { audio } = this.props;
            if (audio.volume > 0) {
                this.lastVolume = audio.volume;
                audio.volume = 0;
            }
            else {
                audio.volume = this.lastVolume;
            }
        };
        this.handleVolumnControlMouseDown = (event) => {
            event.stopPropagation();
            const { audio } = this.props;
            const { currentVolume, currentVolumePos } = this.getCurrentVolume(event.nativeEvent);
            audio.volume = currentVolume;
            this.setState({ isDraggingVolume: true, currentVolumePos });
            if (event.nativeEvent instanceof MouseEvent) {
                window.addEventListener('mousemove', this.handleWindowMouseOrTouchMove);
                window.addEventListener('mouseup', this.handleWindowMouseOrTouchUp);
            }
            else {
                window.addEventListener('touchmove', this.handleWindowMouseOrTouchMove);
                window.addEventListener('touchend', this.handleWindowMouseOrTouchUp);
            }
        };
        this.handleWindowMouseOrTouchMove = (event) => {
            event.preventDefault();
            event.stopPropagation();
            const { audio } = this.props;
            // Prevent Chrome drag selection bug
            const windowSelection = window.getSelection();
            if (windowSelection && windowSelection.type === 'Range') {
                windowSelection.empty();
            }
            const { isDraggingVolume } = this.state;
            if (isDraggingVolume) {
                const { currentVolume, currentVolumePos } = this.getCurrentVolume(event);
                audio.volume = currentVolume;
                this.setState({ currentVolumePos });
            }
        };
        this.handleWindowMouseOrTouchUp = (event) => {
            event.stopPropagation();
            this.setState({ isDraggingVolume: false });
            if (event instanceof MouseEvent) {
                window.removeEventListener('mousemove', this.handleWindowMouseOrTouchMove);
                window.removeEventListener('mouseup', this.handleWindowMouseOrTouchUp);
            }
            else {
                window.removeEventListener('touchmove', this.handleWindowMouseOrTouchMove);
                window.removeEventListener('touchend', this.handleWindowMouseOrTouchUp);
            }
        };
        this.handleAudioVolumeChange = (e) => {
            const { isDraggingVolume } = this.state;
            const { volume } = e.target;
            if ((this.lastVolume > 0 && volume === 0) || (this.lastVolume === 0 && volume > 0)) {
                this.props.onMuteChange && this.props.onMuteChange();
            }
            this.lastVolume = volume;
            if (isDraggingVolume)
                return;
            this.setState({
                hasVolumeAnimation: true,
                currentVolumePos: `${((volume / 1) * 100 || 0).toFixed(2)}%`,
            });
            this.volumeAnimationTimer && clearTimeout(this.volumeAnimationTimer);
            this.volumeAnimationTimer = setTimeout(() => {
                this.setState({ hasVolumeAnimation: false });
            }, 100);
        };
    }
    componentDidUpdate() {
        const { audio } = this.props;
        if (audio && !this.hasAddedAudioEventListener) {
            this.audio = audio;
            this.hasAddedAudioEventListener = true;
            audio.addEventListener('volumechange', this.handleAudioVolumeChange);
        }
    }
    componentWillUnmount() {
        if (this.audio && this.hasAddedAudioEventListener) {
            this.audio.removeEventListener('volumechange', this.handleAudioVolumeChange);
        }
        this.volumeAnimationTimer && clearTimeout(this.volumeAnimationTimer);
    }
    render() {
        const { audio, alignment = 'vertical' } = this.props;
        const { currentVolumePos, hasVolumeAnimation } = this.state;
        const { volume } = audio || {};
        return (React.createElement("div", { ref: (el) => {
                this.volumeBarEl = el;
            }, onMouseDown: this.handleVolumnControlMouseDown, onTouchStart: this.handleVolumnControlMouseDown, role: "progressbar", "aria-label": "volume Control", "aria-valuemin": 0, "aria-valuemax": 100, "aria-valuenow": Number((volume * 100).toFixed(0)), tabIndex: 0, className: classNames("volume-progress-bar", { horizontal: alignment === 'horizontal' }) },
            React.createElement("div", { className: classNames("volume-progress-bar", { horizontal: alignment === 'horizontal' }) },
                React.createElement("div", { className: classNames("volume-progress-bar__point", { horizontal: alignment === 'horizontal' }), style: alignment === 'horizontal' ? { left: currentVolumePos } : { bottom: currentVolumePos } }),
                React.createElement("div", { className: classNames("volume-progress-bar__progress", { horizontal: alignment === 'horizontal' }), style: alignment === 'horizontal' ? { width: currentVolumePos, transitionDuration: hasVolumeAnimation ? '.1s' : '0s' } : { height: currentVolumePos, transitionDuration: hasVolumeAnimation ? '.1s' : '0s' } }))));
    }
}
